export default __webpack_public_path__ + "static/media/TwitterLogo.b413b75b.png";